module.exports={
	"Form": "EquipmentCreateManifest",
	"Scope": "Equipment-Create",
	"Descriptors":
	{
		"EquipmentDetails.Name":
		{
			"Name": "Name",
			"Hash": "Equipment-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Equipment-Create-Identity",
				"Group": "Equipment-Create-Identity"
			}
		},
		"EquipmentDetails.Code":
		{
			"Name": "Code",
			"Hash": "Equipment-Create-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Equipment-Create-Identity",
				"Group": "Equipment-Create-Identity"
			}
		},
		"EquipmentDetails.Description":
		{
			"Name": "Description",
			"Hash": "Equipment-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		},
		"EquipmentDetails.Notes":
		{
			"Name": "Notes",
			"Hash": "Equipment-Create-Notes",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		},
		"EquipmentDetails.SpecificationYear":
		{
			"Name": "Specification Year",
			"Hash": "Equipment-Create-SpecificationYear",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		},
		"EquipmentDetails.Status":
		{
			"Name": "Status",
			"Hash": "Equipment-Create-Status",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		},
		"EquipmentDetails.ExternalEquipmentID":
		{
			"Name": "External Equipment ID",
			"Hash": "Equipment-Create-ExternalEquipmentID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Equipment-Create-Details",
				"Group": "Equipment-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Equipment-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Equipment-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Equipment-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Equipment-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
